import { Fragment, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Divider } from 'shared/ui'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/SenderDetails/hooks/useSenderDetailsContext'
import { BrandContactSectionField } from './BrandContactSectionField'

export const BrandContactSection: FC = observer(() => {
  const {
    brandContactsStore: {
      addNumber,
      canAddNumber,
      numbers,
      removeNumber,
      hasNumbers,
      setNumberLabel,
      addEmail,
      canAddEmail,
      emails,
      removeEmail,
      hasEmails,
      setEmailLabel,
      setEmailValue,
      addWebsite,
      canAddWebsite,
      websites,
      removeWebsite,
      hasWebsites,
      setWebsiteLabel,
      setWebsiteUrl,
      canDeleteNumberOrEmail,
    },
  } = useSenderDetailsContext()

  return (
    <Fragment>
      <BrandContactSectionField
        values={numbers}
        hasValues={hasNumbers}
        canAdd={canAddNumber}
        add={addNumber}
        remove={removeNumber}
        setLabel={setNumberLabel}
        textLabel='Phone'
        textDescription='Up to 3 phone numbers allowed'
        textHeaderValue='Phone number'
        canDelete={canDeleteNumberOrEmail}
        addButtonTooltipProps={{
          label: !canAddNumber ? 'You can add up to 3 phone numbers' : '',
          placement: 'top',
        }}
      />
      <Divider sx={{ borderColor: 'var(--black-10)' }} />
      <BrandContactSectionField
        values={emails}
        hasValues={hasEmails}
        canAdd={canAddEmail}
        add={addEmail}
        remove={removeEmail}
        setLabel={setEmailLabel}
        setValue={setEmailValue}
        textLabel='Email'
        textDescription='Up to 3 email addresses allowed'
        textHeaderValue='Email address'
        valuePlaceholder='Enter email address'
        canDelete={canDeleteNumberOrEmail}
        addButtonTooltipProps={{
          label: !canAddEmail ? 'You can add up to 3 email addresses' : '',
          placement: 'top',
        }}
      />
      <Divider sx={{ borderColor: 'var(--black-10)' }} />
      <BrandContactSectionField
        values={websites}
        hasValues={hasWebsites}
        canAdd={canAddWebsite}
        add={addWebsite}
        remove={removeWebsite}
        setLabel={setWebsiteLabel}
        setValue={setWebsiteUrl}
        textLabel='Website'
        textDescription='Up to 3 URLs allowed'
        textHeaderValue='URL'
        valuePlaceholder='https://'
        addButtonTooltipProps={{
          label: !canAddWebsite ? 'You can add up to 3 websites' : '',
          placement: 'top',
        }}
      />
    </Fragment>
  )
})
